import development from './development';
import test from './test';
import preview from './preview';
import production from './production';

function setConfig(config) {
  const domain = window.location.host;
  let outConfig = null;
  // 本地开发环境：localhost / 127.0.0.1 / [::1] / *.nges.local
  if (/^(localhost|127\.0\.0\.1|\[::1\])/.test(domain) || /\.nges\.local(:\d+)?$/.test(domain)) {
    outConfig = {
      ...config,
      ...development,
    };
    return outConfig;
  }
  const configs = {
    development,
    test,
    preview,
    production,
  };
  Object.keys(configs).forEach((key) => {
    const configItem = configs[key];
    if (configItem.domain.includes(domain)) {
      outConfig = {
        ...config,
        ...configItem,
      };
    }
  });
  if (!outConfig) {
    outConfig = {
      ...config,
      ...production,
    };
  }
  return outConfig;
}
const commonConfig = {
  apiProduct: 1,
  product: 'saas',
  company: 'tencent',
  api: '/api/access/json',
  cloud: '/api/access/pb', // 正常
  workflowCloud: '', // 工作流
  apiList: [], // 非云上接口列表
  whiteFilter: ['SendSmsCode', 'SendEmailCode', 'Login'],
  layoutFilter: ['workflow-detail', 'workflow-edit'],
};
const config = setConfig(commonConfig);
console.log('config', config);
export default config;
